import React from "react";
import {CellTextSmall} from "./index";

export const AdmissionId = ({code}: {code: string}) => (
  <CellTextSmall>Admission ID: {code}</CellTextSmall>
);
